import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { Svg } from '../common/Svg.js';


/* global Uri */

export let FundedProjectsYearFilter = function ({ selectedYear, onClickFundedProjectsYearFilter }) {
    const [showDropdown, setShowDropdown] = React.useState(false);
    const [years, setYears] = React.useState([]);

    React.useEffect(() => {
        const uri = new Uri(location.href);
        uri.addQueryParam('action', 'getYearsForFundedProjectsYearFilter');
        $.get(uri.toString(), function (data) {
            setYears(JSON.parse(data));
        });
    }, []);

    const toggleYearsDropdown = function (e) {
        e.preventDefault();
        setShowDropdown(!showDropdown);
    };

    const onClickAllTime = function (e) {
        onClick(e, true);
    };

    const onClickYear = function (e) {
        onClick(e, false);
    };

    const onClick = function (e, allTime) {
        e.preventDefault();
        const uri = new Uri(location.href);
        // if, for example, the user is viewing the 2nd page of projects from 2017
        // and then selects the year 2016, we want to make sure the user will see
        // the *1st* page of projects from 2016, not the 2nd page, which is why
        // we're removing the 'page' parameter here.
        uri.deleteQueryParam('page');
        if (allTime) {
            uri.deleteQueryParam('fundedProjectsYear');
        } else {
            uri.replaceQueryParam('fundedProjectsYear', $(e.currentTarget).text());
        }
        onClickFundedProjectsYearFilter(uri.toString());
    };

    const renderYearListElements = function () {
        if (years.length === 0 || (years.length === 1 && years[0] === (new Date()).getFullYear())) {
            return;
        }

        return years.map(function (year) {
            return <li key={year} className={year === selectedYear ? 'active' : ''}><a href="#" onClick={onClickYear}>{year}</a></li>;
        });
    };

    return (
        <div className="sort-projects select-with-dropdown">
            <span>show projects from </span>
            <a href="#" onClick={toggleYearsDropdown}>
                <span>{selectedYear || 'all time'}</span>
                <Svg icon="navigatedown" attributes={{ role: 'presentation' }}/>
            </a>
            {showDropdown &&
            <div className="subnav ignore-react-onclickoutside dropdown-options">
                <ul>
                    <li className={selectedYear ? '' : 'active'}><a href="#" onClick={onClickAllTime}>all time</a></li>
                    {renderYearListElements()}
                </ul>
            </div>
            }
        </div>
    );
};

FundedProjectsYearFilter.propTypes = {
    selectedYear: PropTypes.number,
    onClickFundedProjectsYearFilter: PropTypes.func.isRequired,
};

FundedProjectsYearFilter = React.memo(FundedProjectsYearFilter);
